// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".store-list." + "b57e3a0884f69a8c7107" + ".js";
};